// src/components/ControlsBar.js
import React from 'react';

export default function ControlsBar({
  // 상태/값
  stream,
  step,                  // '', 'profile', 'battleMain', 'battleMain2', 'done' 등
  loading,
  memo,
  setMemo,

  // 동작 콜백
  onStartCapture,
  onRunProfile,
  onRunMain,
  onRunMain2,
  onReProfile,
  onRerunBattle,
  onSaveRaid,

  // 옵션
  saveLabel = '저장하기',
  disableStart = false,
  startTooltip = '',

  // ✅ 선택: 저장 후 초기상태로 돌리고 싶을 때만 전달(PartyPage에서만)
  onResetToStart,
}) {
  const hasProfile = typeof onRunProfile === 'function';
  const [saving, setSaving] = React.useState(false);

  // 재실행(캐릭터 정보 단계부터 다시)
  const rerunProfileNow = () => {
    if (loading || !hasProfile) return;
    onReProfile?.();
    requestAnimationFrame(() => onRunProfile?.());
  };

  // 재실행(전투 분석부터 다시)
  const rerunBattleNow = () => {
    if (loading) return;
    onRerunBattle?.();
    requestAnimationFrame(() => onRunMain?.());
  };

  // 프로필 단계로만 이동
  const moveToProfileOnly = () => {
    if (loading || !hasProfile) return;
    onReProfile?.();
  };

  // ✅ 저장 후 초기화(있으면 호출)
  const handleSaveAndReset = async () => {
    if (loading || saving) return;
    try {
      setSaving(true);
      await onSaveRaid?.();   // 원래 저장/공유 로직
      setMemo?.('');          // 메모 초기화(선택)
      onResetToStart?.();     // PartyPage에서만 전달 → 화면 공유 시작 상태로 복귀
    } finally {
      setSaving(false);
    }
  };

  // 1) 화면 공유 전
  if (!stream) {
    return (
      <div className="flex justify-end">
        <button
          onClick={onStartCapture}
          className="btn btn-black"
          disabled={disableStart}
          title={disableStart ? startTooltip : undefined}
        >
          화면 공유 시작
        </button>
      </div>
    );
  }

  // 2) 진행 중 (완료 전)
  if (step !== 'done') {
    let label = '전투 분석기 인식';
    let onClick = onRunMain;

    if (step === 'battleMain2') {
      label = '스크롤 후 전투 분석기 인식';
      onClick = onRunMain2;
    } else if (step === 'profile' && hasProfile) {
      label = '캐릭터 정보 인식';
      onClick = onRunProfile;
    }

    return (
      <div className="flex justify-end items-center gap-2">
        {hasProfile && step !== 'profile' && (
          <button
            onClick={rerunProfileNow}
            disabled={loading}
            className="btn btn-danger"
          >
            캐릭터 정보 인식 재실행
          </button>
        )}

        {step === 'battleMain2' && (
          <button
            onClick={rerunBattleNow}
            className="btn btn-danger"
            disabled={loading}
          >
            전투 분석기 인식 재실행
          </button>
        )}

        <button
          onClick={onClick}
          disabled={loading || !onClick}
          className="btn"
        >
          {label}
        </button>
      </div>
    );
  }

  // 3) 완료 상태
  return (
    <div className="flex justify-end items-center gap-2">
      <button
        onClick={rerunBattleNow}
        className="btn btn-danger"
        disabled={loading}
      >
        전투 분석기 인식 재실행
      </button>

      {hasProfile && (
        <button
          onClick={moveToProfileOnly}
          className="btn btn-primary"
          disabled={loading}
        >
          처음부터 재실행
        </button>
      )}

      <input
        type="text"
        placeholder="메모를 입력하세요 (예: 트포 바꿈, 파티 조합 등)"
        value={memo}
        onChange={e => setMemo(e.target.value)}
        className="
          input
          dark:bg-zinc-800 dark:text-zinc-100 dark:placeholder:text-zinc-400
          dark:border-white/10
          w-64 sm:w-80
        "
      />

      <button
        onClick={handleSaveAndReset}
        className="btn"
        disabled={loading || saving}
      >
        {saving ? '저장 중…' : saveLabel}
      </button>
    </div>
  );
}
